export default "__VITE_ASSET__CrU0HdJ$__"